import React from "react";
import "./LoadingSpinner.scss";

export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner" />
    </div>
  );
}
